/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForSalesForceSalesCloud extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForSalesForceSalesCloud");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForSalesForceSalesCloud.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForSalesForceSalesCloud>): ServiceAccountNativeDetailsForSalesForceSalesCloud {
        let obj = Object.assign(new ServiceAccountNativeDetailsForSalesForceSalesCloud(), model);
        ServiceAccountNativeDetailsForSalesForceSalesCloud.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForSalesForceSalesCloud>): ServiceAccountNativeDetailsForSalesForceSalesCloud {
        if (!model) return null;
        return ServiceAccountNativeDetailsForSalesForceSalesCloud.newInstance(<ServiceAccountNativeDetailsForSalesForceSalesCloud> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForSalesForceSalesCloud) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForSalesForceSalesCloud.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForSalesForceSalesCloud): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForSalesForceSalesCloud.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
